const pageData = {
  no: {
    forestCover: (year, region) => {
      const texts = {
        amazonas: `Amazonas strekker seg over 5,5 millioner kvadratkilometer - et område langt større enn EU. Den enorme Amazonas-elven, med alle sine sideelver, inneholder 20 prosent av verdens rennende ferskvann. På tross av at Amazonas bare dekker fire prosent av jordoverflaten, kan den innholde så mye som en tredjedel av verdens kjente plante-, dyre- og insektsarter.`,
        africa: `Den frodige regnskogen i Sentral-Afrika strekker seg over nesten 1.8 millioner kvadratkilometer, helt fra de store sjøene i øst til Guineagulfen i vest. Området er om lag 4,5 ganger større enn Norge, og det inneholder 18 prosent av all regnskog i verden. Halvparten av dette området er ansett som intakt regnskog. `,
        asia: `Regnskogen i denne regionen er blant de mest komplekse og artsrike økosystemene i verden. Den er blant annet kjent for elefanter og orangutanger, og det er registrert så mye som 3000 plantetyper. Skogen brer seg ut over mange land, og den er størst i Indonesia, Malaysia og Papua Ny-Guinea. `
      }
      return {
        slug: 'skogdekke',
        name: 'Skogdekke',
        sub: `km<sup>2</sup> i ${year}`,
        desc: `<h1 class="text-3xl mb-4">Skogdekke</h1><p class="leading-7">${texts[region]}</p>`
      }
    },
    forestLoss: (year, region) => {
      const texts = {
        amazonas: `Siden 1950-tallet er nesten 20 prosent av Amazonas helt avskoget og opp til 50 prosent er delvis ødelagt. Nye landbruksområder og beitemark for husdyr er hovedårsaken til ødeleggelsene. Andre virksomheter som truer regnskogen er olje- og gassutvinning, gruvedrift, tømmerdrift og infrastrukturprosjekter som demninger og veier. `,
        africa: `Avskogingen øker i Kongobassenget. I dag er det småskala svedjejordbruk som er hovedårsaken til avskoging i DR Kongo. Flere land i regionen har planer om å tiltrekke seg internasjonale investeringer. Industriell hogst, plantasjer og industrielt jordbruk representerer derfor de største truslene for Kongobassengets regnskog i framtiden.`,
        asia: `Hvert år brennes store skogområder i Sørøst-Asia for å gjøre plass til palmeoljeplantasjer og andre plantasjer, og de voldsomme brannene fører til enorme utslipp av klimagasser. Det hogges også ned mye skog, i tillegg til at gruvedrift, demningsutbyging og annen infrastruktur fortrenger regnskog i hele regionen.`
      }
      return {
        slug: 'skogtap',
        name: 'Avskoging',
        sub: `km<sup>2</sup> siden ${year}`,
        desc: `<h1 class="text-3xl mb-4">Avskoging</h1><p class="leading-7">${texts[region]}</p>`
      }
    },
    fire: () => {
      return {
        slug: 'skogbrann',
        name: 'Skogbrann',
        sub: `aktive branner siste døgnet`,
        desc: `<h1 class="text-3xl mb-4">Skogbranner</h1><p class="leading-7">Brann er et økende problem i regnskogen, og et tegn på at skogen er skadet. En intakt regnskog kan nemlig ikke brenne på grunn av et naturlig høyt fuktighetsnivå. Men når regnskogen tynnes ut og stykkes opp vil solstråler begynne å tørke ut skogbunnen og gjøre den antennelig. Det har gjort at Amazonas nå har én tørkeperiode i året. En vanlig brannårsak er at skog har blitt hogd og deretter påtent for å rydde nye jordbruksområder.</p>`
      }
    }
  },
  en: {
    forestCover: (year, region) => {
      const texts = {
        amazonas: `The Amazon rainforest is the biggest in the world and stretches across 5.5 million square kilometers, an area far more extensive than the EU and more than half of the US. The enormous Amazon river, with all its tributaries, contains 20 percent of the world’s flowing fresh water. The forest contains a third of all known terrestrial plant, animal, and insect species.`,
        africa: `The lush rainforest of Central Africa covers almost 1.8 million square kilometres, all the way from the African Great Lakes Region to the Gulf of Guinea, and 18 percent of the worlds remaining rainforests are found here. Half of the rainforest in Central Africa is considered intact.`,
        asia: `This region’s rainforests are among the most complex and species-rich ecosystems in the world. Southeast Asian rainforests are renowned for the elephants and orangutans that live in them, and more than 3,000 species of plant have been registered. The countries with the largest remaining forests are Indonesia, Malaysia and Papua New Guinea.`
      }
      return {
        slug: 'forestcover',
        name: 'Forest cover',
        sub: `km<sup>2</sup> in ${year}`,
        desc: `<h1 class="text-3xl mb-4">Forest cover</h1><p class="leading-7">${texts[region]}</p>`
      }
    },
    forestLoss: (year, region) => {
      const texts = {
        amazonas: `Since the 1950s, almost 20 percent of the Amazon rainforest has been deforested and as much as 50 percent of the original forest has been partly damaged. Agricultural activities are the main cause of deforestation in the Amazon. Other threats to the rainforest include oil and gas exploration, mining, logging, dams and road construction.`,
        africa: `Deforestation is increasing in the Congo Basin. Today, small scale slash and burn agriculture is the main cause of deforestation in DR Congo. Several countries in the region have plans to attract foreign investments, and because of this industrial logging, plantations and industrial agriculture represent the biggest threats to the Congo Basin forest in the future.`,
        asia: `The rainforests in this region are under tremendous pressure, with large, contiguous forests remaining only on the islands of Borneo and New Guinea. Every year, vast areas of forest in Southeast Asia are burned to make way for oil palm and other plantations. Also, over the last four decades, Indonesia, Malaysia and Papua New Guinea have permitted a massive expansion of plantation, logging and mining activities.`
      }
      return {
        slug: 'foresloss',
        name: 'Deforestation',
        sub: `km<sup>2</sup> since ${year}`,
        desc: `<h1 class="text-3xl mb-4">Deforestation</h1><p class="leading-7">${texts[region]}</p>`
      }
    },
    fire: () => {
      return {
        slug: 'forestfires',
        name: 'Forest fires',
        sub: `active fires past 24 hrs.`,
        desc: `<h1 class="text-3xl mb-4">Forest fires</h1><p class="leading-7">Fire is an increasing problem in the rainforest as well as a clear sign the rainforest is damaged. An intact rainforest cannot burn because of the damp conditions and high humidity. But as deforestation and selective logging breaks the forest’s thick canopy and allows sun rays to dry the forest floor, the forest itself becomes susceptible to fires. A common fire cause is slash and burn approach to deforest land for agriculture.</p>`
      }
    }
  }
}

const localizedStrings = {
  en: {
    title: 'State of the rainforest',
    footerTitle:
      'State of the rainforest is a data portal developed by <a href="https://www.regnskog.no/en/">Rainforest Foundation Norway</a>.',
    dataSources: 'Data sources',
    downloadLinkLabel: 'Download data (csv)',
    forestCitations:
      'Forest cover: Computations based on <a class="link" href="https://kartoteket.as/citations/forest-cover-loss-2000-2018/">Hansen Global Forest Change</a>',
    deforestationCitations:
      'Deforestation: <a class="link" href="https://kartoteket.as/citations/forest-cover-loss-2000-2018/">Hansen Global Forest Change</a>',
    fireCitations:
      'Forest fires: FIRMS data from <a class="link" href="https://kartoteket.as/citations/firms-fire-data/">Suomi NPP satellite</a>',
    websiteLink: '<a class="link" href="https://www.regnskog.no/en/">Rainforest Foundation</a>',
    memberOfText:
      'Rainforest Foundation Norway is a member of the Norwegian Control Committee for Fundraising and is certified by Eco-Lighthouse.',
    madewithpride: 'Code, maps and numbers by '
  },
  no: {
    title: 'Regnskogens tilstand',
    footerTitle: 'Regnskogens tilstand er en dataportal utviklet av <a href="https://www.regnskog.no/en/">Regnskogfondet</a>.',
    dataSources: 'Datakilder',
    downloadLinkLabel: 'Last ned data (csv)',
    forestCitations:
      'Skogdekke: Beregninger basert på <a class="link" href="https://kartoteket.as/citations/forest-cover-loss-2000-2018/">Hansen Global Forest Change</a>',
    deforestationCitations:
      'Avskoging: <a class="link" href="https://kartoteket.as/citations/forest-cover-loss-2000-2018/">Hansen Global Forest Change</a>',
    fireCitations:
      'Skogbranner: FIRMS data fra <a class="link" href="https://kartoteket.as/citations/firms-fire-data/">Suomi NPP satellite</a>',
    websiteLink: '<a class="link" href="https://www.regnskog.no/no/">Regnskogfondet</a>',
    memberOfText: 'Regnskogfondet er medlem av Innsamlingskontrollen og er Miljøfyrtårn-sertifisert.',
    madewithpride: 'Kode, kart og tall fra '
  }
}

export default {
  get: (lang, dimension) => {
    return pageData[lang][dimension]
  },
  localizedString: (id, language) => {
    return localizedStrings[language][id]
  }
}
